class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.searchIcon = this.querySelector('.search-icon-h');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.input.addEventListener('click', this.onInputClick.bind(this));
    }

    window.addEventListener('resize', this.handleWindowResize.bind(this));
    this.handleWindowResize();
  }


  toggleSearchIconVisibility(visible) {
    if (this.searchIcon) {
      this.searchIcon.style.display = visible ? 'flex' : 'none';
    }
  }

  onChange() {
    this.toggleSearchIconVisibility(this.input.value.length === 0);
  }

  onFormReset(event) {
    event.preventDefault();
    this.input.value = '';
    this.input.focus();
  }

  onInputFocus() {
    this.toggleSearchIconVisibility(false);
  }

  onInputBlur() {
    if (this.input.value === '') {
      this.toggleSearchIconVisibility(true);
    }
  }

  onInputClick() {
    this.toggleSearchIconVisibility(false);
  }

  handleWindowResize() {
    const isMobile = window.innerWidth <= 768;
    this.isMobile = isMobile;

    if (this.isMobile) {
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.input.addEventListener('click', this.onInputClick.bind(this));
    } else {
      this.input.removeEventListener('focus', this.onInputFocus.bind(this));
      this.input.removeEventListener('blur', this.onInputBlur.bind(this));
      this.input.removeEventListener('click', this.onInputClick.bind(this));
    }
  }
}

customElements.define('search-form', SearchForm);